<template>

<!-- htmlファイル側の「<router-view>」内に表示する内容 -->
  <nav class="" id="vy_header ">
    <h1  v-on:click="home" style="cursor:pointer">
      <img id="by-logo" src="../../images/logo.png" alt="ボラ活エール" />
    </h1>

    <div class="container">

      <br>
      <button v-if="edit_update == 1"  class="btn btn-primary mx-aut" style="width: 100%; height: 50px;padding: 0;background-color: red;" v-on:click="update" >保存する</button>
      <button v-else class="btn btn-primary mx-aut" style="width: 100%; height: 50px;padding: 0;background-color: lightgrey;">保存する</button>

    </div>

  </nav>

</template>

<script setup>
/* eslint-disable */

import { ref } from 'vue'
import { useRouter,useRoute } from 'vue-router'
import { login_check } from '../js/userdata_shisetsu.js';

const router = useRouter();
let route = useRoute()

login_check()

// 親コンポーネントから送られてきた値
const props = defineProps(['param']);

// 親（ShisetsuSetting）から送られたフラグによって保存ボタンの色を変える（edit_update = 0：未編集、1：編集、2：画面描画中につきボタンに影響させない）
// let edit_update = ref(props.param.edit_update) 
let edit_update = ref(0) 
if(props.param.edit_update){
  edit_update.value = 1
} 

// 親コンポーネントに送る値
const emit = defineEmits(['call'])

// 更新ボタン
let update = function(){
  emit('call',{cmd:'facility_update'});
}
//------------------------------ リンク --------------------------------
const home = function() {
    router.push("/"+route.params.shakyo+"/"+route.params.shisetsu+"/Shisetsu")
}

</script>
<style scoped>

</style>


